module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"_","commonjs2":"immutable","commonjs":"immutable","amd":"immutable","umd":"immutable"}
// module id = 5
// module chunks = 0 1 2 3 4 5